<template>
  <div class="right-panel">
    <div class="row mb-3">
      <div class="col col-12 form-input">
        <a title="Back to programs" href="#" @click="backToProgram"><i class="bi bi-arrow-left"></i></a>
        <span @click="backToProgram" class="back">Back</span>
      </div>
    </div>
    <div class="row mb-3" v-if="(disabledCRUDState == true && !isOrgUser)">
      <div id="DisabledCRUD-Message" style="background-color:lightyellow; padding: 10px; color: gray;">
        <p style="margin-bottom: 0;">[Add a participant] and [Move a participant] (<i class="bi bi-arrow-left-right"></i>) are temporarily disabled until the system goes live. </p>
        <p style="margin-bottom: 0;">Thank you for understanding!</p>
      </div>
    </div>
    <div class="row mb-3" v-if="isValidProgram">
      <div class="col col-xs-6 col-sm-6 pt-3">
        <h2>View Participants</h2>
        <h5 v-if="programData">
          {{ `${programData.programName}` }}
          <span class="par-count" v-if="programData">
            {{ `(${totalCount} of ${programData.participantMaxCount})` }}</span>
        </h5>
        <a :href="participantReportUrl" target="_blank">Participant Report</a>
      </div>
      <div class="col col-xs-6 col-sm-6 text-right">
        <button class="btn btn-primary" 
        :disabled="(programData && programData.participantMaxCount <= totalCount) || (disabledCRUDState == true && !isOrgUser)"
          @click="onAddClick">
          Add a participant
        </button>
      </div>
    </div>
    <div v-else>
      <h3>You do not have permissions to access this.</h3>
    </div>
    <div class="row" v-if="isValidProgram">
      <div class="col col-xs-12 col-sm-6 form-input">
        <label for="basic-url">Search by Name</label>
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Enter first or last name"
            aria-label="Enter first or last name" @input="searchByNameDebounce" />
        </div>
      </div>
    </div>

    <div class="table-wrapper" v-if="isValidProgram">
      <EasyDataTable v-model:server-options="serverOptions" table-class-name="datatable" :headers="headers"
        :items="items" :server-items-length="totalCount" :loading="isLoadingRegisteredParticipants" buttons-pagination
        :alternating="true" @expand-row="" must-sort class="data-table">
        <template #item-buttons="item">
          <div class="icon-col">
            <button 
            title="Move Participant" 
            class="icon-move" 
            :disabled="(disabledCRUDState == true && !isOrgUser)"
            @click="() => openProgramsModal(item)">
              <i class="bi bi-arrow-left-right"></i>
            </button>
            <button :disabled="item.totalAmountPaid == 0 ||
              item.status.toUpperCase() != 'COMPLETED' ||
              !item.detailId ||
              item.isManuallyCreated == 'Yes' ||
              !item.isPaidOnline ||
              (item.isManuallyAdded == 'Yes' &&
                !item.oldParticipationRegistrationDetailUID)
              ||
              (!item.isPaidOnline &&
                !item.oldParticipationRegistrationDetailUID)
              " title="Refund" class="icon-refund" @click="() => refund(item)">
              <i class="bi currency">{{ currency }}</i>
            </button>
            <button title="Edit" class="icon-edit" :disabled="item.isManuallyCreated == 'No'"
              @click="() => editRegistration(item)">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button title="Delete" class="icon-delete" @click="() => onDeleteParticipants(item)">
              <i class="bi bi-trash ms-1"></i>
            </button>
          </div>
        </template>
        <template #expand="item">
          <div class="pa-4" v-if="programCategoryId == 1">
            <div class="row pb-4">
              <div class="col">
                <b>Guardian First Name: </b>
                <span>{{ item.guardianFirstName ?? "N/A" }}</span>
              </div>
              <div class="col" v-if="programCategoryId == 1">
                <b>Guardian Surname: </b>
                <span>{{ item.guardianLastName ?? "N/A" }}</span>
              </div>
              <div class="col">
                <b>Club Hand: </b>
                <span>{{
                  item.playingHand ? (item.playingHand == "R" ? "Right" : "Left") : "N/A"
                }}</span>
              </div>
              <div class="col">
                <b>D.O.B: </b>
                <span>{{ item.dob ?? "N/A" }}</span>
              </div>
            </div>
            <div class="row pb-4">
              <div class="col">
                <b>Disability: </b>
                <span v-if="item.hasSpecialNeeds != null">{{ item.hasSpecialNeeds == "True" ? "Yes" : "No" }}</span>
              </div>
              <div class="col">
                <b>Disability Comments: </b>
                <span>{{ item.specialNeedsComment ?? "N/A" }}</span>
              </div>
              <div class="col">
                <b>Medical Info: </b>
                <span>{{ item.otherComments ?? "N/A" }}</span>
              </div>
              <div class="col"></div>
            </div>
          </div>
          <div class="pa-4" v-else>
            <div class="row pb-4">
              <div class="col">
                <b>Club Hand: </b>
                <span>{{
                  item.playingHand ? (item.playingHand == "R" ? "Right" : "Left") : "N/A"
                }}</span>
              </div>
              <div class="col">
                <b>D.O.B: </b>
                <span>{{ item.dob ?? "N/A" }}</span>
              </div>

              <div class="col">
                <b>Disability: </b>
                <span v-if="item.hasSpecialNeeds != null">{{ item.hasSpecialNeeds == "True" ? "Yes" : "No" }}</span>
              </div>
              <div class="col">
                <b>Disability Comments: </b>
                <span>{{ item.specialNeedsComment ?? "N/A" }}</span>
              </div>
              <div class="col">
                <b>Medical Info: </b>
                <span>{{ item.otherComments ?? "N/A" }}</span>
              </div>
            </div>
          </div>
        </template>
      </EasyDataTable>
    </div>
  </div>

  <Modal title="Remove participant" ref="deleteModal" class="modal-inline">
    <template #body>
      <p>
        This participant will be permanently removed from this {{ terms?.Program.toLowerCase() }}.
        <span class="text-danger">
          PLEASE NOTE - ANY REFUNDS THAT NEED TO BE GIVEN MUST BE DONE BEFORE DELETION.
        </span>
      </p>
      Are you sure you want to remove
      <strong>{{ `${selectedItem?.firstName + " " + selectedItem?.lastName}` }}</strong>
      <span> from </span><strong>{{ `${selectedItem?.programName}` }}</strong>?
    </template>
    <template #footer>
      <button class="btn btn-danger" @click="() => onClickRemove()">Remove</button>
    </template>
  </Modal>

  <Modal title="Refund" ref="refundModal" width="50%" class="modal-inline">
    <template #body>
      <div class="row pb-4" v-if="selectedItem && targetRegistration">
        <div class="col-sm-12 mb-3">
          <div v-if="targetRegistration.details.length > 1" class="mb-4">
            <b>Note: The payment for the selected participant is part of a
              multiple-participant registration. The payment details below include all
              participants in the same group payment.</b>
          </div>
          <div>{{ terms?.Program }} Name: {{ `${selectedItem.programName} ` }}</div>
        </div>
        <div class="col-sm-12 mb-4">
          <div class="mb-3"><b>Payment Details & Refund</b></div>
          <div class="box" v-if="!isLoadingRegistration && targetRegistration">
            <div class="container" v-for="detail in targetRegistration.details">
              <div class="row wrap border-bottom py-2">
                <div class="col-sm-4 px-0 pr-0 pl-3 py-1">
                  {{ `${detail.firstName} ${detail.lastName} ${terms?.Program} Cost` }}
                  <div class="subtitle">
                    <p class="caption">
                      Original Amount:
                      {{
                        detail.programAmount <= 0 ? `${currency}0.00` : `${currency}${(detail.oldProgramAmount ?
                          formatCurrency(detail.oldProgramAmount) : formatCurrency(detail.programAmount))}` }} </p>
                        <p class="caption" v-if="detail.activeKidsVoucherAmount">
                          AK Voucher:
                          {{ `${currency}${formatCurrency(detail.activeKidsVoucherAmount)}` }}
                        </p>
                        <p class="caption" v-if="detail.voucherDiscountAmount">
                          {{ detail.voucherDescription }}:
                          {{ `${currency}${formatCurrency(detail.voucherDiscountAmount)}` }}
                        </p>
                  </div>
                </div>
                <div class="col-sm-2 px-0 py-1 text-right">
                  {{
                    detail.amountDue <= 0 ? `${currency}0.00` : `${currency}${detail.oldAmountDue ?
                      formatCurrency(detail.oldAmountDue) : formatCurrency(detail.amountDue)}` }} </div>
                    <div class="col-sm-4 px-0 pt-1 align-right">
                      <input type="number" maxlength="7" step="0.01"
                        v-if="isClubhouseUser && detail.amountDue > 0 && detail.programAmount > 0 && !detail.oldParticipationRegistrationDetailUID"
                        :disabled="isLoadingRefund ||
                          targetRegistration.transactionStatus == 'Refunded'
                          " class="form-control form-control-sm refund-input refund-amount-input" v-model="detail.amountToRefund"
                        placeholder="Enter Amount" />
                    </div>
                    <div class="col-sm-1 r-2 pt-1 align-right">
                      <button class="btn btn-primary btn-sm"
                        v-if="isClubhouseUser && detail.amountDue > 0 && detail.programAmount > 0 && !detail.oldParticipationRegistrationDetailUID"
                        :disabled="isLoadingRefund ||
                          targetRegistration.transactionStatus == 'Refunded' ||
                          !isValidRefundAmount(detail.amountToRefund, detail.amountDue)
                          " @click="() =>
                            onRefundClick(
                              RefundTypeEnum.ProgramCost,
                              detail.amountToRefund,
                              detail.participationRegistrationDetailUID
                            )
                          ">
                        {{
                          targetRegistration.transactionStatus == "Refunded"
                            ? "Refunded"
                            : "Refund"
                        }}
                      </button>
                    </div>
                </div>
                <div class="row wrap border-bottom py-2"
                  v-if="settings.showParticipantPack && (detail.myGolfPackFee && detail.myGolfPackFee > 0) || (detail.oldMyGolfPackFee && detail.oldMyGolfPackFee > 0)">
                  <div class="col-sm-4 px-0 pr-0 pl-3 py-2">
                    {{
                      `${detail.firstName} ${detail.lastName} Participant
                    Pack
                    Cost`
                    }}
                  </div>
                  <div class="col-sm-2 px-0 pt-2 text-right">
                    {{ `${currency}${detail.oldMyGolfPackFee ? formatCurrency(detail.oldMyGolfPackFee) :
                      formatCurrency(detail.myGolfPackFee)}` }}
                  </div>
                  <div class="col-sm-4 px-0 pt-1 align-right">
                    <input type="text" readonly
                      class="form-control form-control-sm refund-input refund-amount-input" :value="`${currency}${formatCurrency(detail.transferAmount ?? 0)}`"
                      v-if="isOrgUser && !detail.oldParticipationRegistrationDetailUID"
                      :disabled="isLoadingRefund || (detail.transferStatus != 'Pending' && detail.transferStatus != 'Completed') || targetRegistration.transactionStatus == 'Refunded'" />
                  </div>
                  <div class="col-sm-1 pl-2 pr-0 pt-1 align-right">
                    <button class="btn btn-primary btn-sm"
                      v-if="isOrgUser && !detail.oldParticipationRegistrationDetailUID" :disabled="isLoadingRefund ||
                        targetRegistration.transactionStatus == 'Refunded' ||
                        (detail.transferStatus != 'Pending' && detail.transferStatus != 'Completed') ||
                        !(detail.transferAmount > 0)
                        " @click="() =>
                          onRefundClick(
                            RefundTypeEnum.PackCost,
                            detail.transferAmount,
                            detail.participationRegistrationDetailUID
                          )
                        ">
                      {{
                        detail.transferStatus == "Refunded" ||
                          detail.transferStatus == "Refunded"
                          ? "Refunded"
                          : detail.transferStatus == "PendingRefund" || detail.transferStatus == "RefundedApplicationFee"
                            ? "Pending"
                            : "Refund"
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="settings.isProcessingFeeRemovalActive" class="container">
                <div class="row wrap border-bottom py-2">
                  <div class="col-sm-12 px-0 pr-0 pl-3 py-1">
                    Please note that Stripe do not return the processing fee to the venue when a refund is issued to a participant, regardless of the reason for the refund. Venues should consider their own individual circumstances and applicable legal obligations when determining refund amounts.
                  </div>
                </div>
              </div>
              <div class="container">
                <div v-if="settings.isProcessingFeeRemovalActive || selectedItem.inclusiveProcessingFee == null"
                  class="row wrap border-bottom py-2">
                  <div class="col-sm-4 px-0 pr-0 pl-3 py-1">{{ processingFeeLabel(settings.isProcessingFeeRemovalActive) }}</div>
                  <div class="col-sm-2 px-0 py-1 text-right">
                    {{ `${currency}${formatCurrency(processingFeeAmount(selectedItem.fee, selectedItem.inclusiveProcessingFee))}` }}
                  </div>
                  <div class="col-sm-6"></div>
                </div>
              </div>
              <div class="container">
                <div class="row wrap border-bottom py-2">
                  <div class="col-sm-4 px-0 pr-0 pl-1 pt-2">Total Amount Paid</div>
                  <div class="col-sm-2 px-0 pt-2 text-right">
                    <b>{{
                      `${currency}${selectedItem.oldTotalAmountPaid ? formatCurrency(selectedItem.oldTotalAmountPaid) :
                        formatCurrency(selectedItem.totalAmountPaid)}`
                    }}</b>
                  </div>
                  <div class="col-sm-4 px-0 pt-1 align-right">
                    <!-- <input type="text" maxlength="100" v-if="!hasRefundHistories && isOrgUser" disabled
                    class="form-control form-control-sm refund-input" v-model="totalAmountRefund"
                    placeholder="Total Amount Paid" /> -->
                  </div>
                  <div class="col-sm-1 pl-2 pr-0 pt-1 align-right">
                    <!-- <button class="btn btn-primary btn-sm" v-if="!hasRefundHistories && isOrgUser"
                    :disabled="isLoadingRefund || targetRegistration.transactionStatus == 'Refunded'"
                    @click="() => onRefundClick(RefundTypeEnum.TotalCost, totalAmountRefund, 0)">
                    Refund
                  </button> -->
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <span class="spinner-border spinner-border-sm"></span>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="mb-3"><b>Refund History</b></div>
            <EasyDataTable alternating table-class-name="datatable" :headers="refundHeaders" :items="refundHistories"
              header-text-direction="center" body-text-direction="center" :loading="isLoadingRegistration"
              buttons-pagination must-sort class="data-table">
              <template #item-dateCompleted="item">
                {{ formatDateToGrid(item.dateCompleted) }}
              </template>
              <template #item-amount="item" style="text-align: right">
                {{ `${currency}${formatCurrency(item.amount)}` }}
              </template>
            </EasyDataTable>
          </div>
        </div>
    </template>
  </Modal>

  <Modal title="Remove participant" ref="deleteModalWithConfirmation" width="30%" class="modal-inline">
    <template #body>
      <div v-html="settings.deleteModalWithConfirmationText"></div>
    </template>
  </Modal>

  <Modal title="Refund Confirmation" ref="refundConfirm" width="30%" class="modal-inline">
    <template #body>
      <p>
        Are you sure you want to refund the
        <b>{{ parseRefundType(refundType) }} of
          {{ `${currency}${formatCurrency(amountToRefund)}?` }}</b>
      </p>
    </template>
    <template #footer>
      <button class="btn btn-primary" @click="onRefundYes">Refund</button>
    </template>
  </Modal>

  <Modal title="Are you sure? This action cannot be undone." ref="programsModal" width="50%" class="modal-inline">
    <template #body>
      <div class="container">
        <div class="row mb-3">
          Yes, I'd like to move this participant to the following {{ terms?.Program.toLowerCase() }}.
          Any additional payments/refunds associated with moving this participant are the responsibility of the venue.
          <div class="text-danger p-0 pt-3" v-if=isPaidOnline>
            Please note – Once a participant has been moved, the venue will not be able to process a refund to this
            participant in {{ settings.platformShortName }}.
          </div>
        </div>
        <div class="row mb-3 mx-1">
          <!-- Check if there are no programs available -->
          <span v-if="programOptions === null || programOptions.length === 0" class="px-0 pb-2 error">No Programs
            available</span>
          <!-- If there are programs, display them as radio buttons -->
          <div v-else>
            <div class="col col-12 form-check" v-for="option in programOptions" :key="option.programUID">
              <input :id="`${option.programUID}`" class="form-check-input" type="radio" :value="option.programUID"
                v-model="newProgramUID" @change="($event) => moveToProgram($event)" />
              <label :for="`${option.programUID}`" class="form-check-label">
                {{ option.programName }},
                {{ moment(option.startDate).format("DD MMM YYYY") }} -
                {{ moment(option.endDate).format("DD MMM YYYY") }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="row col-7">
        <div class="col-12">
          <div class="error mb-2" v-if="isProgramFull">
            Unable to move participant. {{ terms?.Program }} is already full.
          </div>
        </div>
      </div>
      <button v-if="programOptions != null && programOptions.length > 0" class="btn btn-primary"
        :disabled="programUID == newProgramUID || isSavingProgram" @click="() => confirmMoving()">
        <span v-if="isSavingProgram" class="spinner-border spinner-border-sm"></span>
        Confirm
      </button>
    </template>
  </Modal>

  <Notification ref="programMsg" colorScheme="text-bg-success">
    <template #body> Successfully Moved! </template>
  </Notification>

  <Notification ref="notificationMsg" colorScheme="text-bg-success">
    <template #body>
      Successfully removed!
      <strong v-if="selectedItem">{{
        `${selectedItem?.firstName + " " + selectedItem?.lastName}`
      }}</strong>
    </template>
  </Notification>

  <Notification ref="refundNotificationMsg" colorScheme="text-bg-success">
    <template #body>
      Successfully refunded
      <strong v-if="selectedItem">{{
        `${selectedItem?.firstName + " " + selectedItem?.lastName}`
      }}</strong>
    </template>
  </Notification>

  <Notification ref="unSuccessfulRefundNotificationMsg" colorScheme="text-bg-warning">
    <template #body>
      Refund unsuccessful, please contact the Participation Team for help.
    </template>
  </Notification>
</template>

<script setup lang="ts">
import type { Item, ServerOptions } from "vue3-easy-data-table";
import { ref, watch, onMounted, computed } from "vue";
import { useProgramStore } from "@/stores/program-store";
import { debounce } from "lodash";
import Modal from "@/components/common/Modal.vue";
import Notification from "@/components/common/Notification.vue";
import moment from "moment";
import { useAuthStore } from "@/stores/auth-store";
import { storeToRefs } from "pinia";
import router from "@/router";
import { useRoute } from "vue-router";
import { useCurrencyStore } from "@/stores/currency-store";
import { useRefundStore } from "@/stores/refund-store";
import { formatCurrency, formatDateToGrid } from "../tools/utils";
import { initialRefundAmount, isValidRefundAmount, processingFeeAmount, processingFeeLabel } from "@/tools/refund-display";
import { RefundTypeEnum } from "@/enums/refundTypeEnum";
import { RefundStatusEnum } from "@/enums/refundStatusEnum";
import { useSettingStore } from "@/stores/setting-store";
import { useTermsStore } from "@/stores/language-terms";
const { terms } = storeToRefs(useTermsStore());

const route = useRoute();
const { getDefaultCurrency } = useCurrencyStore();
const { currency } = storeToRefs(useCurrencyStore());

const { getSetting } = useSettingStore();
const { setting } = storeToRefs(useSettingStore());
const settings = ref(setting);

const {
  getProgramParticipants,
  removeProgramParticipant,
  loadRelatedPrograms,
  registerSelectedParticipants,
  postProgramParticipantHistory,
  getParticipationRegistrationById,
} = useProgramStore();

const { getLoginOrgInfo } = useAuthStore();
const { isLoadingRefund } = storeToRefs(useRefundStore());
const { refundRegistration } = useRefundStore();
const { getProgramById } = useProgramStore();
const {
  participants,
  totalCount,
  isLoadingRegisteredParticipants,
  programData,
  programOptions,
  isLoadingRegistration,
  isSavingProgram,
} = storeToRefs(useProgramStore());
const { orgInfo, orgUrl, liveUrl, isOrgUser, isClubhouseUser, clubUID } = storeToRefs(
  useAuthStore()
);

const selectedItem = ref();
const searchByName = ref();
let deleteModal = ref<any | null>(null);
let refundModal = ref<any | null>(null);
let notificationMsg = ref<any | null>(null);
let refundNotificationMsg = ref<any | null>(null);
let unSuccessfulRefundNotificationMsg = ref<any | null>(null);

let refundConfirm = ref<any | null>(null);
let targetRegistration = ref<any | null>(null);
let isProgramFull = ref(false);

const programAmountRefund = ref(0);
const refundType = ref(RefundTypeEnum.ProgramCost);
const totalAmountRefund = ref();
const amountToRefund = ref();
const refundDetailId = ref();

const isValidProgram = ref(true);

const disabledCRUDState = settings.value.disabledCRUD && !settings.value.clubUIDsWhitelistedToEnabledCRUD.includes(clubUID.value);

const programUID = computed(() => {
  return route.params.programUID ? route.params.programUID as string : "";
});

const programCategoryId = ref(null);

const venueId = computed(() => {
  return route.params.venueId ? parseInt(route.params.venueId as string) : -1;
});

const isPaidOnline = computed(() => {
  return itemToMove && itemToMove?.value?.isManuallyAdded == "No" && itemToMove?.value?.isManuallyCreated == "No";
});

const hasRefundHistories = computed(() => {
  return (
    targetRegistration.value &&
    targetRegistration.value.refundHistory &&
    targetRegistration.value.refundHistory.length > 0
  );
});

const searchByNameDebounce = debounce(($event) => {
  if ($event.target.value && $event.target.value.length <= 2) return;
  searchByName.value = $event.target.value;
}, 500);

const items = ref<Item[]>([]);
const itemToMove = ref<Item>();
const headers = [
  {
    text: "First Name",
    value: "firstName",
    sortable: true,
  },
  {
    text: "Last Name",
    value: "lastName",
    sortable: true,
  },
  {
    text: "Gender",
    value: "gender",
    sortable: true,
  },
  {
    text: "Email",
    value: "guardianEmail",
    sortable: true,
  },
  {
    text: "Phone",
    value: "guardianPhone",
    sortable: true,
  },
  {
    text: "Manually Created?",
    value: "isManuallyCreated",
    sortable: true,
  },
  {
    text: "",
    value: "move",
    sortable: false,
  },
  {
    text: "",
    value: "buttons",
    sortable: false,
  },
];

const refundHeaders = [
  {
    text: "Name",
    value: "name",
    sortable: true,
  },
  {
    text: "Participant",
    value: "participantName",
    sortable: true,
  },
  {
    text: "Amount",
    value: "amount",
    sortable: true,
    direction: "center",
  },
  {
    text: "Status",
    value: "status",
    sortable: true,
  },
  {
    text: "Date Completed",
    value: "dateCompleted",
    sortable: true,
  },
];

const serverOptions = ref<ServerOptions>({
  page: 1,
  rowsPerPage: 20,
  sortBy: "dateCreated",
  sortType: "asc",
});

const refundServerOptions = ref<ServerOptions>({
  page: 1,
  rowsPerPage: 30,
  sortBy: "dateCompleted",
  sortType: "desc",
});

const shouldDisableItem = (item) => {
  return item && item.totalAmountPaid == 0 ||
    item.status.toUpperCase() != 'COMPLETED' ||
    !item.detailId ||
    (item.isManuallyCreated == 'Yes' &&
      !item.oldParticipationRegistrationDetailUID)
    ||
    (item.isManuallyAdded == 'Yes' &&
      !item.oldParticipationRegistrationDetailUID)
}

const loadProgramParticipants = async () => {
  await getProgramParticipants(
    programUID.value,
    searchByName.value,
    serverOptions.value.page,
    serverOptions.value.rowsPerPage,
    serverOptions.value.sortBy,
    serverOptions.value.sortType
  );
  items.value = participants.value;
};

onMounted(async () => {
  await getLoginOrgInfo();
  await getProgramById(programUID.value, orgInfo?.value?.clubId);
  await getSetting();

  programCategoryId.value = programData.value.programCategoryId;
  if (programData.value) {
    isValidProgram.value = true;
  } else {
    isValidProgram.value = false;
  }

  await loadProgramParticipants();
  await loadRelatedPrograms(programUID.value);
  await getDefaultCurrency();
});

watch([searchByName, serverOptions], async () => {
  await loadProgramParticipants();
});

watch([selectedItem], (value) => {
  if (value) {
    programAmountRefund.value = selectedItem.value.programAmount;
    totalAmountRefund.value = selectedItem.value.totalAmountPaid;
  }
});

const loadRegistration = async () => {
  await getSetting();
  if (typeof settings.value.isProcessingFeeRemovalActive !== "boolean") {
    return false;
  }

  var result = await getParticipationRegistrationById(selectedItem.value.id);
  if (result) {
    result.details.forEach((detail) => {
      detail.amountDue =
        detail.amountDue - detail.activeKidsVoucherAmount - detail.voucherDiscountAmount;
      detail.amountToRefund = initialRefundAmount(
        settings.value.isProcessingFeeRemovalActive,
        detail.amountDue
      );
    });
    targetRegistration.value = Object.assign({}, result);
    return true;
  }

  return false;
};

const backToProgram = async () => {
  await router.push({
    name: "Participation",
    query: route.query,
  });
};

const participantReportUrl = computed(() => {
  return `${isOrgUser.value ? orgUrl.value : liveUrl.value
    }Shared/Reports/ExtQueryRender.aspx?ExtQueryResourceName=Participation.ParticipantsReport&ProgramCategoryId=${(programData.value) ? programData.value.programCategoryId : ''}&VenueId=&ProgramUID=${programUID.value
    }&FromDate=&ToDate=&FinancialYear=`;
});

const refundHistories = computed(() => {
  return targetRegistration.value && targetRegistration.value.refundHistory
    ? targetRegistration.value.refundHistory
    : [];
});

let deleteModalWithConfirmation = ref<any | null>(null);
const onDeleteParticipants = (item: any) => {
  selectedItem.value = Object.assign({}, item);

  //only if Golf Australia user(gaadmin as orgUser)
  //and Program.EndDate > CurrentDate then can remove the selected participant show delete modal
  //otherwise show confirm delete modal
  if (!isOrgUser.value && item.endDate < item.currentDate) {
    if (deleteModalWithConfirmation.value) {
      deleteModalWithConfirmation.value.show();
    }
  } else {
    if (deleteModal.value) {
      deleteModal.value.show();
    }
  }
};

const onClickRemove = async () => {
  const result = await removeProgramParticipant(selectedItem.value.detailId);

  if (result) {
    deleteModal?.value?.hide();
    deleteModalWithConfirmation?.value?.hide();
    notificationMsg?.value?.show();

    // DG-22029: Refresh program data so capacity-driven UI (Full badge,
    // move-program modal capacity gate, etc.) re-evaluates from 'Full' status to 'Register'.
    await getProgramById(programUID.value, orgInfo?.value?.clubId);
    
    await loadProgramParticipants();
  }
};

const onAddClick = async () => {
  if(disabledCRUDState == true && !isOrgUser.value) {
    return;
  }
  await router.push({
    name: "ProgramParticipantsSelection",
    params: {
      programUID: programUID.value,
    },
    query: route.query,
  });
};

const editRegistration = async (item: any) => {
  await router.push({
    name: "ParticipantsProgramRegistration",
    params: {
      programUID: programUID.value,
      rId: item.id,
      rdId: item.detailId,
    },
  });
};

const refund = async (item: any) => {
  selectedItem.value = Object.assign({}, item);
  if (await loadRegistration()) {
    refundModal?.value?.show();
  }
};

const onRefundClick = (type: RefundTypeEnum, amount: number, detailId: number) => {
  if (type == RefundTypeEnum.ProgramCost) {
    const detail = targetRegistration.value.details.find(
      (registrationDetail) => registrationDetail.participationRegistrationDetailUID == detailId
    );
    if (!detail || !isValidRefundAmount(amount, detail.amountDue)) {
      return;
    }
  }

  refundType.value = type;
  refundConfirm?.value?.show();
  amountToRefund.value = amount;
  refundDetailId.value = detailId;
};

const onRefundYes = async () => {
  refundConfirm?.value?.hide();
  const data = {
    participationRegistrationUID: targetRegistration.value.participationRegistrationUID,
    participationRegistrationDetailUID: refundDetailId.value,
    programUID: programUID.value,
    amount: amountToRefund.value,
    refundType: refundType.value,
  };

  const result = await refundRegistration(data);
  if (result != RefundStatusEnum.Invalid) {
    refundNotificationMsg?.value?.show();
    await loadRegistration();
  } else {
    unSuccessfulRefundNotificationMsg?.value?.show();
  }
};

let programsModal = ref<any | null>(null);
const participationRegistrationUID = ref();
const participationRegistrationDetailUID = ref();
let participationRegistrationDetailIds = [] as { id: string }[];
const memberUID = ref();
const openProgramsModal = (item: any) => {
  if(disabledCRUDState == true && !isOrgUser.value) {
    return;
  }
  isProgramFull.value = false;
  if (programsModal.value) {
    programsModal.value.show();
  }

  participationRegistrationDetailIds = [] as { id: string }[];
  participationRegistrationUID.value = item.id;
  participationRegistrationDetailUID.value = item.detailId;
  participationRegistrationDetailIds.push({ id: item.detailId });
  itemToMove.value = item;
  memberUID.value = item.memberUID;
};

//MZ: change 'newProgramUID' default value as 0 instead of programUID.value
//MZ: coz when 'close' or 'X' modal 'programsModal' the radio does not reset it will make button 'Confirm' disabled
const newProgramUID = ref("");
const moveToProgram = (event: any) => {
  newProgramUID.value = event.target.value;
};

const showSelectProgram = ref(false);
let programMsg = ref<any | null>(null);
const confirmMoving = async () => {
  showSelectProgram.value = false;
  if (!newProgramUID.value || newProgramUID.value == "") {
    showSelectProgram.value = true
    return;
  }

  isProgramFull.value = false;
  //step 1: insert one record into Entity 'ParticipationRegistration' with selected newProgramUID
  //step 1: and insert one record into Entity 'ParticipationRegistrationDetail'
  const resultFromInsert = await registerSelectedParticipants(
    participationRegistrationDetailIds.map((x) => x.id),
    newProgramUID.value,
    true
  );

  if (resultFromInsert) {
    //step 2: update status ='Withdrawn' in Entity 'ParticipationRegistrationDetail'
    const resultFromDelete = await removeProgramParticipant(
      participationRegistrationDetailIds[0].id
    );

    if (resultFromDelete) {
      //step 3: Add one record into the new Entity 'ProgramParticipantHistory'
      const resultHistory = await postProgramParticipantHistory(
        programUID.value,
        newProgramUID.value,
        participationRegistrationDetailUID.value
      );

      if (resultHistory) {
        if (programsModal.value) {
          programsModal.value.hide();
        }
        if (programMsg.value) {
          programMsg.value.show();
        }
        await loadProgramParticipants();
      }
    }
  } else {
    isProgramFull.value = true;
  }
};

const parseRefundType = (type: RefundTypeEnum) => {
  if (type == RefundTypeEnum.ProgramCost) {
    return `${terms.value?.Program} Cost`;
  }
  return "Participant Pack Cost";
};

const validateInput = (detail) => {
  if (detail.amountToRefund > detail.amountDue || detail.amountToRefund == 0) {
    detail.amountToRefund = detail.amountDue;
  }
};
</script>

<style scoped>
.box {
  border: solid 1px #ebebeb;
  padding: 0 10px 10px 10px;
}

.border-bottom {
  border-bottom: solid 1px #ebebeb;
  --bs-gutter-x: 1.3rem;
}

.mr-1 {
  margin-right: 10px !important;
}

label.form-label {
  font-size: 13px;
}

.delivererModal .form-input label {
  padding-bottom: 5px;
  margin-bottom: 0;
}

.delivererModal .form-input {
  margin-bottom: 10px;
}

.par-count {
  font-size: 16px;
}

.text-right {
  text-align: right;
}

.subtitle {
  font-size: 12px;
}

.error {
  display: block;
  width: 100%;
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

.back {
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
}

.align-right {
  text-align: -webkit-right;
}

.refund-input {
  width: 100px;
}

.refund-amount-input {
  width: 110px;
  font-size: 0.75rem;
}

.caption {
  padding: 0;
  margin: 0;
}

.icon-refund {
  padding-left: 10px;
}

.bi.currency {
  font-size: 16px;
}
</style>
